import { render, staticRenderFns } from "./OsTestsForm.vue?vue&type=template&id=668f2a3c"
import script from "./OsTestsForm.vue?vue&type=script&lang=js"
export * from "./OsTestsForm.vue?vue&type=script&lang=js"
import style0 from "./OsTestsForm.vue?vue&type=style&index=0&id=668f2a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports